<template>
  <section class="download">
    <form @submit.prevent="handleDownload">
      <f-card>
        <template>
          <div class="main flex flex-space">
            <div class="label-group">
              <span class="label">Mois</span>
              <f-select
                id="month"
                v-model="selectedMonth"
                label="label"
                :options="months"
                placeholder="Choisir un mois"
                :showLabels="false"
                :searchable="false"
                >
              </f-select>
            </div>
          </div>
        </template>

        <template slot="footer">
          <div class="footer flex flex-right">
            <ab-button class="primary" @click="showModal">Générer</ab-button>
          </div>
        </template>
      </f-card>
    </form>

    <f-modal class="modal" name="download" height="auto">
      <section>
        <f-card>
          <main>
            <p>Le fichier est prêt à être téléchargé.</p>
          </main>
          <footer class="flex flex-right">
            <a class="btn-action primary"
              :href="href"
              target="_blank"
              :download="download"
              @click="$modal.hide('download')">Télécharger</a>
          </footer>
        </f-card>
      </section>
    </f-modal>
  </section>
</template>

<script>
  import AbButton from '@/components/form/button/ab-button.vue';
  import CSelect from '@/components/form/select/c-select.vue';
  import FCard from '@/components/layout/card/f-card.vue';
  import { mapState } from 'vuex';
  import messages from '../messages/messages.js';
  import { getMonthList } from '@/js/getMonthList.js';

  export default {
    name: "Bill",
    components: {
      AbButton,
      CSelect,
      FCard
    },
    mounted() {
      this.months = getMonthList(this.monthsDisplayed);
    },
    data() {
      return {
        monthsDisplayed: 6,
        months: [],
        selectedMonth: '',
        filePath: '',
        href: '#',
        download: '',
      }
    },
    computed: {
      ...mapState({ clientId: function(state) { return state.client } }),
      startDate() {
        if (this.type) { return this.type.timestamp; }
        return Date.now();
      },
      endDate() {
        if (this.startDate) { return new Date(this.startDate).setMonth(new Date(this.startDate).getMonth()+1); }
        return Date.now();
      },
    },
    methods: {
      async handleDownload() {
        if (this.selectedMonth) {
          if (this.clientId) {
            const month = new Date(this.selectedMonth.timestamp);
            const data = await this.$store.dispatch('exportBill', {
              clientId: this.clientId,
              month: month.getMonth()+1,
              year: month.getFullYear(),
            });
            if (data) {
              this.filePath = data;
              this.showModal();
            }
          }
        } else {
          this.displayToast({ message: messages.selectors.Download.custom.selectedMonth, mode: 'error' });
        }
      },
      showModal() {
        const date = new Date(this.selectedMonth.timestamp);
        const month = this.formatDate(date);
        this.href = `${process.env.VUE_APP_ROOT_API}${this.filePath}`;
        this.download = `factures_${month}.zip`;

        this.$modal.show('download', {});
      },
      /**
       * @see https://stackoverflow.com/questions/23593052/format-javascript-date-to-yyyy-mm-dd
       */
      formatDate(d) {
        let month = `${d.getMonth() + 1}`;
        let year = `${d.getFullYear()}`;
        if (month.length < 2) month = `0${month}`;
        return [ month, year ].join('-');
      }
    },
  }
</script>

<style scoped>
  /* Main */
  .main {
    margin-bottom : 1rem;
  }
  .label-group {
    min-width: 40%;
  }
  .label-group .label {
    font-size: 15px;
    font-weight: 600;
    margin-right: 1rem;
  }
  .label-group .c-select {
    width: 20rem;
  }
</style>